import Spinner from 'react-bootstrap/Spinner';

function Loader() {
  return <Spinner animation="grow" />;
}

export default Loader;